import { render, staticRenderFns } from "./regular_mobile.vue?vue&type=template&id=c609263c&scoped=true&"
import script from "./regular_mobile.vue?vue&type=script&lang=js&"
export * from "./regular_mobile.vue?vue&type=script&lang=js&"
import style0 from "./regular_mobile.vue?vue&type=style&index=0&id=c609263c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c609263c",
  null
  
)

export default component.exports